import { Box, Button, Typography } from "@mui/material";
import { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const FourOhFour = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Fragment>
      <Helmet>
        <title>
          {t("fourOhFour.pageTitle", {
            appName: process.env.REACT_APP_APP_NAME,
          })}
        </title>
      </Helmet>
      <Box
        sx={{
          display: "flex",
          position: "absolute",
          inset: 0,
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          paddingX: 5,
          backgroundColor: "#FFFFFF",
          height: "100vh",
          color: "black",
          textAlign: "center",
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: { md: "350px", xs: "150px", sm: "220px" },
            fontWeight: "bold",
            letterSpacing: "-0.05em",
            color: "primary.main",
          }}
        >
          {t("fourOhFour.title")}
        </Typography>
        <Typography
          variant="h4"
          sx={{ fontWeight: "600", mt: 1 }}
          color="common.black"
        >
          {t("fourOhFour.heading")}
        </Typography>
        <Typography
          variant="body1"
          color="common.black"
          sx={{
            mt: 1,
            fontWeight: 400,
            fontSize: "16px",
            maxWidth: "500px",
            mx: "auto",
          }}
        >
          {t("fourOhFour.description")}
        </Typography>
        <Button
          variant="contained"
          sx={{
            mt: 3,
            paddingX: 4,
            paddingY: 1.5,
            fontSize: "16px",
            borderRadius: "50px",
            boxShadow: 4,
            "&:hover": {
              boxShadow: "0px 10px 15px rgba(0, 0, 0, 0.2)",
            },
          }}
          onClick={() => {
            navigate("/");
          }}
          color="secondary"
        >
          {t("fourOhFour.button")}
        </Button>
      </Box>
    </Fragment>
  );
};

export default FourOhFour;
